<template>
  <div class="tab-content">
    <el-tabs activeName="first">
      <el-tab-pane :label="$t('vendor_tab_files_first')" name="first">
        <el-card>
          <div v-if="showUploadPercentage" class="progress">
            <el-progress :percentage="uploadPercentage"></el-progress>
          </div>
          <form class="loading"
                :class="{
                  'is-dragover': dragover
                }"
                @drop.prevent="onDrop"
                @dragover.prevent="onDragover"
                @dragleave.prevent="dragover = false">
            <label for="file" class="loading__label">
              <i class="el-icon-upload"></i>
              {{$t('project_tab_files_first_title')}}
            </label>
            <input ref='file' v-show="false" @change="handleFile" id="file" name="myFile" type="file">
          </form>
          <el-button disabled @click="createNewFileOpenModal(selectedRow)" type="primary" size="mini" plain>{{$t('general_createNewFile')}}</el-button>
          <el-table
              :key="tableKey"
              :data="newFileList"
              style="width: 100%; margin-top:10px;"
              :empty-text="$t('general_noData')"
              @cell-click="cellClick"
              :cell-class-name="cellClassName"
              :row-class-name="tableRowClassName"
              row-key="id"
              size="mini"
              border>
            <el-table-column width="50">

            </el-table-column>
            <el-table-column
                :label="$t('project_tab_files_first_fileNo')"
                width="60">
              <template slot-scope="scope">
                <div class="file__item_id" v-if="scope.row.orderIndex">{{scope.row.orderIndex}} </div>
              </template>
            </el-table-column>
            <el-table-column
                :label="$t('project_tab_files_first_ver')"
                width="50">
              <template slot-scope="scope">
                <div class="file__item_id" v-if="scope.row.rev">{{scope.row.rev}} </div>
              </template>
            </el-table-column>
            <el-table-column
                width="50">
              <template slot-scope="scope">
                <fileImg style="width:30px;" :url="scope.row.url.split('.').pop().toUpperCase()"/>
              </template>
            </el-table-column>
            <el-table-column
                :label="$t('project_tab_files_first_name')">
              <template slot-scope="scope">
                {{scope.row.name }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('project_tab_files_first_size')">
              <template slot-scope="scope">
                {{scope.row.size }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('project_tab_files_first_date')">
              <template slot-scope="scope">
                {{scope.row.date }}
              </template>
            </el-table-column>
            <el-table-column
                width="150"
                :label="$t('project_tab_files_first_user')">
              <template slot-scope="scope">
                {{scope.row.user }}
              </template>
            </el-table-column>
            <el-table-column
                width="100">
              <template slot-scope="scope">
                <el-dropdown>
                    <span class="el-dropdown-link">
                      {{$t('project_tab_files_first_action')}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="viewFile(scope.row.url, scope.row, 60, false)" icon="el-icon-view" :disabled="scope.row.isEditNow">{{$t('project_tab_files_first_view')}}</el-dropdown-item>
                    <el-dropdown-item v-if="ifCanEdit(scope.row.url)" @click.native="editFile(scope.row.url, scope.row, 'project', selectedRow.vendorId, null)" icon="el-icon-edit-outline" :disabled="scope.row.isEditNow">{{$t('project_tab_files_edit_file')}}</el-dropdown-item>
                    <el-dropdown-item @click.native="downloadFiles(scope.row.url, scope.row.name, scope.row)" class="download-btn" icon="el-icon-upload" :disabled="scope.row.isEditNow">{{$t('project_tab_files_first_download')}}</el-dropdown-item>
                    <el-dropdown-item :disabled="scope.row.isEditNow">
                      <form>
                        <label>
                          <div v-show="!scope.row.parentId" class="btn">
                            <i class="el-icon-upload2"></i>{{$t('project_tab_files_first_uploadRevision')}}
                          </div>
                          <input ref='fileUpg' v-show="false" @change="upgradeFile($event, scope.row.id)" name="myFile" type="file">
                        </label>
                      </form>
                    </el-dropdown-item>
                    <el-dropdown-item :disabled="scope.row.isEditNow" @click.native="deleteFile(scope.row)" icon="el-icon-delete">{{$t('project_tab_files_first_delete')}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>

          <div v-if="viewerType == 1">
            <sweet-modal v-if="viewerType == 1" ref="nestedChild">
              <iframe class="iframe" :src="fileUrl" frameborder="0"></iframe>
            </sweet-modal>
          </div>
          <div v-if="viewerType == 2">
            <div v-show="false" class="images" v-viewer="getViewerSettings">
              <img :src="fileUrl" :key="fileUrl" />
            </div>
          </div>
          <div class="mod" v-if="viewerType == 3">
            <div @click="closeMod" class="mod__close">
              <span>x</span>
            </div>
            <Media
                :kind="'video'"
                :controls="true"
                :src="fileUrl"
            >
            </Media>
          </div>
          <div class="mod" v-if="viewerType == 4">
            <div @click="closeMod" class="mod__close">
              <span>x</span>
            </div>
            <Media
                :kind="'audio'"
                :controls="true"
                :src="fileUrl"
            >
            </Media>
          </div>

          <!--View File Modal Start-->
          <el-dialog :title="$t('viewProjectFiles')" :visible.sync="docsDialog" fullscreen @close="closeDocViewModal" custom-class="docs-dialog">
            <div style="height: calc(100vh - 90px);">
              <div id="placeholder-1"></div>
            </div>
          </el-dialog>
          <!--View File Modal End-->

          <el-dialog :title="$t('project_tab_files_edit_file')" :visible.sync="docsEditDialog" fullscreen @close="closeDocEditCreatedFileModal" custom-class="docs-dialog">
            <div style="height: calc(100vh - 90px);">
              <div id="placeholder-2"></div>
            </div>
          </el-dialog>

        </el-card>
      </el-tab-pane>
    </el-tabs>
    <create-new-file-modal ref="createNewFileModal" @openCreatedFile="openCreatedFile"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { viewEditFileMixin } from '../../mixins/viewEditFileMixin'
import fileImg from '../fileImg'
import Media from '@dongido/vue-viaudio'
import axios from 'axios'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue';
import CreateNewFileModal from "../createNewFileModal/index";
export default {
  name: 'vendorFilesTab',
  components: {
    CreateNewFileModal,
    SweetModal,
    fileImg,
    Media,
    vueDropzone: vue2Dropzone
  },
  props: [
    'selectedRow'],
  mixins: [viewEditFileMixin],
  data() {
    return {
      activeStar: 'el-icon-star-on',
      notActiveStar: 'el-icon-star-off',
      showUploadPercentage: false,
      uploadPercentage: 0,
      dragover:false,

      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        maxFiles: 1,
        thumbnailWidth: 200,
        maxFilesize: 0.5,
        headers: { "My-Awesome-Header": "header value" },
        addRemoveLinks: true,
        uploadMultiple: false,
      },
      fileSavingNotification: null,
      tableKey: 0,
      ifNeedToConvertMov: false
    }
  },
  computed: {
    ...mapGetters([
      'getNotificationDuration',
      'getViewerSettings'
    ]),
    newFileList() {
      return this.$store.state.clientsFiles
    }
  },
  created(){
    let docApiScript = document.createElement('script');
    docApiScript.setAttribute('src', 'https://office2.totalflow.io/web-apps/apps/api/documents/api.js');
    document.head.appendChild(docApiScript);
  },
  methods: {
    downloadFiles(url, name, row) {
      // document.location.href = `${url + '/' + encodeURIComponent(name)}?mode=attachment`;
      document.location.href = row.urlDownload

      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/history/create`, {
          companyId: this.$route.query.companyId,
          entityTypeId: 85,
          entityId: this.$route.query.companyClientId,
          taskId: null,
          logAction: 'download',
          logType: 'File',
          fileParams: {
            id: row.fileServiceId,
            pathToDownload: row.url,
            originalName: row.name,
            createdDate: row.date,
            allFileId: row.id,
          }
        })
        .then(response => {
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        })
    },
    openCreatedFile(data) {
      this.editCreatedFile(data.fileUrl, data, 'vendor', this.selectedRow.vendorId, null)
    },
    openWarningModalAll(row) {
      this.$confirm(this.$t('project_tab_files_first_delete_text'), this.$t('project_tab_files_first_delete_title'), {
        distinguishCancelAndClose: true,
        type: 'info',
        confirmButtonText: this.$t('project_tab_files_first_delete_current'),
        cancelButtonText: this.$t('project_tab_files_first_delete_all')
      })
          .then(() => {
            this.deleteFileCurrent(row)
          })
          .catch(action => {
            if (action === 'cancel') {
              this.deleteFileAll(row)
            }
          });
    },
    deleteFileCurrent(row) {
      this.$confirm(this.$t('file_thisWillPermanentlyDeleteTheFileContinue'), this.$t('notification_title_warning'), {
        confirmButtonText: this.$t('general_ok'),
        cancelButtonText: this.$t('general_cancel'),
        type: 'info'
      }).then(() => {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .get(`/api/v1/entityFiles/delete?companyId=${this.$route.query.companyId}&fileId=${row.id}&entityId=${this.selectedRow.vendorId}&entityTypeId=85&deleteChild=false&taskId=null&historyEntityId=${this.$route.query.companyClientId}`)
            .then(response => {
              this.$store.dispatch('getVendorsFiles')
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        });
      });
    },
    deleteFileAll(row) {
      this.$confirm(this.$t('file_thisWillPermanentlyDeleteTheFilesContinue'), this.$t('notification_title_warning'), {
        confirmButtonText: this.$t('general_ok'),
        cancelButtonText: this.$t('general_cancel'),
        type: 'info'
      }).then(() => {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .get(`/api/v1/entityFiles/delete?companyId=${this.$route.query.companyId}&fileId=${row.id}&entityId=${this.selectedRow.vendorId}&entityTypeId=85&deleteChild=true&taskId=null&historyEntityId=${this.$route.query.companyClientId}`)
            .then(response => {
              this.$store.dispatch('getVendorsFiles')
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        });
      });
    },
    async onDrop(e) {
      // check if mov file uploaded
      const file = e.dataTransfer.files[0];
      const ifMov = this.movChecker(e.dataTransfer.files[0]);
      if (ifMov === 'cancel') return;
      this.ifNeedToConvertMov = false;
      if (ifMov) {
        this.ifNeedToConvertMov = await this.askBeforeMovUploaded();
        if (this.ifNeedToConvertMov === 'closeModal') {
          this.resetInputs();
          return
        }
      }
      console.log('file.name --')
      const formData = new FormData();
      formData.append('file', file);
      this.ifNeedToConvertMov ?  formData.append('convert', 'true') : formData.append('convert', 'false');
      //check equals start
      console.log('file.name', file.name)
      const fileName = file.name.trim();

      let index = null;
      // Find coincidence of names in table function
      const even = function (element) {
        if (element.name.trim() === fileName){
          index = element.id;
          return element.name.trim() === fileName;
        }
      };

      // Find coincidence
      if (this.newFileList.some(even)) {
        // change e for function friendly
        e.target.files = e.dataTransfer.files;
        this.ifFileExist(file, index);
        return
      }
      //check equals end

      const config = {
        onUploadProgress: (progressEvent) => {
          this.uploadPercentage = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        }
      };
      formData.append('entityId', this.selectedRow.vendorId);
      formData.append('entityTypeId', 85);
      formData.append('oldParentId', null);
      formData.append('taskId', null);
      formData.append('historyEntityId', this.$route.query.companyClientId);
      let loader = this.$loading.show();
      this.showUploadPercentage = true
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .post(`/api/v1/entityFiles/create?companyId=${this.$route.query.companyId}`, formData, config)
          .then(response => {
            console.log('---vendorFiles/create', response.data);
            this.notification("Success", "File upload", "success");
            this.$store.dispatch('getVendorsFiles');
            this.resetInputs();
            loader.hide();
            this.showUploadPercentage = false
            this.uploadPercentage = 0
            this.dragover = false
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide();
            this.showUploadPercentage = false;
            this.uploadPercentage = 0;
            this.dragover = false;
          });
    },
    askBeforeMovUploaded(){
      return new Promise (resolve => {
        this.$confirm(this.$t('modal_convertMovToMP4'), this.$t('general_info'), {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$t('general_convert'),
          cancelButtonText: this.$t('modal_convertMovToMP4_no'),
          type: 'info'
        }).then(() => {
          resolve(true)
        }).catch(action => {
          if (action === 'cancel') return resolve(false);
          return resolve('closeModal')
        });
      });
    },
    onDragover() {
      this.dragover = true;
    },
    ifFileExist(file, index){
      return new Promise ((resolve, reject) => {
        this.$confirm(`The file with Similar name is already present, new version will be added automatically`,{
          dangerouslyUseHTMLString: true,
          confirmButtonText: 'Upload',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.upgradeExistedFile(file, index);
          resolve(true)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Cancel'
          });
        });
        this.resetInputs();
        this.dragover = false
      })
    },
    async upgradeExistedFile(file, index) {
      // check if mov file uploaded

      const formData = new FormData();
      formData.append('file', file);
      this.ifNeedToConvertMov ?  formData.append('convert', 'true') : formData.append('convert', 'false');

      const config = {
        onUploadProgress: (progressEvent) => {
          this.uploadPercentage = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        }
      };
      formData.append('entityId', this.selectedRow.vendorId);
      formData.append('entityTypeId', 85);
      formData.append('oldParentId', index);
      formData.append('taskId', null);
      formData.append('historyEntityId', this.$route.query.companyClientId);
      let loader = this.$loading.show();
      this.showUploadPercentage = true;
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .post(`/api/v1/entityFiles/create?companyId=${this.$route.query.companyId}`, formData, config)
          .then(response => {
            console.log('---vendorFiles/create', response.data);
            this.notification("Success", "New File Version Uploaded", "success")
            this.$store.dispatch('getVendorsFiles')
            this.resetInputs();
            loader.hide()
            this.showUploadPercentage = false
            this.uploadPercentage = 0
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
            this.showUploadPercentage = false
            this.uploadPercentage = 0
          });
    },
    deleteFile(row) {
      if (row.children.length) {
        this.openWarningModalAll(row)
      } else {
        this.deleteFileCurrent(row)
      }
    },
    cellClick(row, column, event){
      if(column.label === 'Name' && !row.isEditNow){
        this.viewFile(row.url, row, 60, false)
      }
    },
    cellClassName({row, column, rowIndex, columnIndex}){
      if(columnIndex === 3 || columnIndex === 4){
        return 'file-name'
      }
    },
    closeMod() {
      this.viewerType = 0;
    },
    show() {
      const viewer = this.$el.querySelector('.images').$viewer
      viewer.show()
    },
    async handleFile(e) {
      // check if mov file uploaded
      const file = e.target.files[0];
      const ifMov = this.movChecker(e.target.files[0]);
      if (ifMov === 'cancel') return;
      this.ifNeedToConvertMov = false;
      if (ifMov) {
        this.ifNeedToConvertMov = await this.askBeforeMovUploaded();
        if (this.ifNeedToConvertMov === 'closeModal') {
          this.resetInputs();
          return
        }
      }

      const formData = new FormData();
      formData.append('file', file);
      this.ifNeedToConvertMov ?  formData.append('convert', 'true') : formData.append('convert', 'false');

      //check equals start
      const fileName = file.name.trim();

      let index = null;
      // Find coincidence of names in table function
      const even = function (element) {
        if (element.name.trim() === fileName){
          index = element.id;
          return element.name.trim() === fileName;
        }
      };
      // Find coincidence
      if (this.newFileList.some(even)) {
        // change e for function friendly
        this.ifFileExist(file, index);
        return
      }
      //check equals end

      const config = {
        onUploadProgress: (progressEvent) => {
          this.uploadPercentage = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        }
      };

      formData.append('entityId', this.selectedRow.vendorId);
      formData.append('entityTypeId', 85);
      formData.append('oldParentId', null);
      formData.append('taskId', null);
      formData.append('historyEntityId', this.$route.query.companyClientId);
      let loader = this.$loading.show();
      this.showUploadPercentage = true;
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .post(`/api/v1/entityFiles/create?companyId=${this.$route.query.companyId}`, formData, config)
          .then(response => {
            console.log('---vendorFiles/create', response.data);
            this.notification("Success", "File upload", "success")
            this.$store.dispatch('getVendorsFiles')
            this.resetInputs();
            loader.hide()
            this.showUploadPercentage = false
            this.uploadPercentage = 0
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
            this.showUploadPercentage = false
            this.uploadPercentage = 0
          });
    },
    checkType(url) {
      let type = url.split('.').pop().toUpperCase()

      if (type == 'GIF' || type == 'STEP' || type == 'STP' || type == 'IGES' || type == 'IGS' || type == 'BREP' || type == 'STL' || type == 'SAT' || type == 'X_T' || type == 'X_B' || type == 'SLDPRT' || type == 'DWG' || type == 'DXF' || type == 'DWF' || type == 'HPGL' || type == 'PLT' || type == 'CGM' || type == 'SVG' || type == 'EMF' || type == 'WMF' || type == 'JPG' || type == 'JPEG' || type == 'PNG' || type == 'BMP' || type == 'OGG' || type == 'MP4' || type == 'WMA' || type == 'MP3' || type == 'WAV' || type == 'OGG' || type == 'M4A' || type == 'PDF') {
        return true
      } else {
        return false
      }
    },
    async upgradeFile(e, index) {
      // check if mov file uploaded
      const ifMov = this.movChecker(e.target.files[0]);
      if (ifMov === 'cancel') return;
      this.ifNeedToConvertMov = false;
      if (ifMov) {
        this.ifNeedToConvertMov = await this.askBeforeMovUploaded();
        if (this.ifNeedToConvertMov === 'closeModal') {
          this.resetInputs();
          return
        }
      }

      const formData = new FormData();
      formData.append('file', e.target.files[0]);
      this.ifNeedToConvertMov ?  formData.append('convert', 'true') : formData.append('convert', 'false');

      const config = {
        onUploadProgress: (progressEvent) => {
          this.uploadPercentage = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        }
      };
      formData.append('entityId', this.selectedRow.vendorId);
      formData.append('entityTypeId', '85');
      formData.append('oldParentId', index);
      formData.append('taskId', null);
      formData.append('historyEntityId', this.$route.query.companyClientId);
      let loader = this.$loading.show();
      this.showUploadPercentage = true;
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .post(`/api/v1/entityFiles/create?companyId=${this.$route.query.companyId}`, formData, {'Content-Type': 'multipart/form-data'})
          .then(response => {
            console.log('---vendorFiles/create', response.data);
            this.notification("Success", "New File Version Uploaded", "success")
            this.$store.dispatch('getVendorsFiles')
            this.resetInputs();
            loader.hide();
            this.showUploadPercentage = false
            this.uploadPercentage = 0
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
            this.showUploadPercentage = false
            this.uploadPercentage = 0
          });
    },
    createNewFileOpenModal(selectedRow){
      this.$refs.createNewFileModal.openModal(selectedRow, 'vendor')
    },
    closeDocViewModal(){
      this.docEditor.destroyEditor();
      this.type = '';
      this.fileUrl = '';
      this.viewerType = 0;
      this.docsDialog = false;
      this.docEditor = {}
    },
    closeDocEditCreatedFileModal(){
      this.docEditor.destroyEditor();
      this.type = '';
      this.fileUrl = '';
      this.viewerType = 0;
      this.docsEditDialog = false;
      this.docEditor = {};
      this.$store.dispatch('hideFileNotification', 0);
      this.fileSavingNotification = this.$notify({
        title: this.$t('general_info'),
        message: this.$t('general_fileIsSavingItWillTakeSomeTime'),
        type: 'info',
        duration: 12000
      });
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    tableRowClassName({row, rowIndex}) {
      if (row.isEditNow) return 'disabled-row';
      return '';
    },
    resetInputs(){
      if (this.$refs.fileUpg) this.$refs.fileUpg.value = null;
      if (this.$refs.file) this.$refs.file.value = null;
    }
  },
  watch:{
    getNotificationDuration(val){
      if (this.fileSavingNotification && val === 500) {
        this.fileSavingNotification.duration = 500;
        this.fileSavingNotification = null;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.progress {
  margin-bottom: 15px;
}
.mod {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0,0,0,0.8);
  z-index: 99999;
  &__close {
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    cursor: pointer;
    height: 80px;
    overflow: hidden;
    position: absolute;
    right: -40px;
    top: -40px;
    -webkit-transition: background-color 0.15s;
    transition: background-color 0.15s;
    width: 80px;
    span {
      color: #fff;
      bottom: 15px;
      left: 15px;
      position: absolute;
      z-index: 99999;
    }
  }
  video {
    height: 80%;
  }
}
.loading {
  display: flex;
  width: 100%;
  margin-bottom: 10px;
  // padding-top:35px;
  &__label {
    width: 100%;
    height: 180px;
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    text-align: center;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    color: #606266;
    font-size: 14px;
    z-index: 0;

    &:hover {
      border-color: #409EFF;
    }
    .el-icon-upload {
      display: block;
      font-size: 67px;
      color: #C0C4CC;
      margin: 40px 0 16px;
      line-height: 50px;
    }
    span {
      color: #409EFF;
    }
  }
  &.is-dragover{
    border: 1px dashed #409EFF;
    border-radius: 6px;
    .loading__label{
      background-color:rgba(32,159,255,.06);
    }
  }
}

.tree {
  width: 100%;
  font-size: 12px;
  .file {
    border-bottom: 1px dashed #d9d9d9;
    &:last-child {
      border-bottom: none;
    }
    &__item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;

      &_link {
        display: flex;
        justify-content: flex-end;
        width: 153px;

        .btn {
          color: #409EFF;
          background: #ecf5ff;
          border: 1px solid #b3d8ff;
          margin-left: 10px;
          padding: 7px 15px;
          font-size: 12px;
          border-radius: 3px;
          cursor: pointer;
          &:hover {
            background: #409EFF;
            border-color: #409EFF;
            color: #FFF;
          }
        }
      }

      &_id {
        width: 20px;
        text-align: center;
      }
      &_name {
        width: 250px;
        cursor: pointer;
      }
      &_size {
        white-space: nowrap;
        text-align: center;
      }
      &_date {
        width: 100px;
        text-align: center;
      }
      &_user {
        width: 120px;
        text-align: center;
      }
    }
  }
}

.padding-left {
  padding-left: 10px;
}
.font-weight {
  font-weight: 700;
}

.iframe{
  width:640px;
  height:700px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}
/deep/.download-btn{
  a{
    color:#606266;
    &:hover{
      color:#66b1ff;
    }
  }
}
/deep/.file-name{
  &:hover{
    cursor:pointer;
  }
}
/deep/.el-table .disabled-row {
  background: #F5F7FA;
  cursor: no-drop;
}
</style>
